module.exports = __webpack_public_path__ + "static/media/nivas.50c2e1b0.png";